import { GetServerSidePropsContext } from 'next';
import { Institution } from '../Institutions/institution';

export enum Resources {
  eTRF = 'eTRF',
  ordersListView = 'Orders List View',
  kitOrdering = 'Sample Kit Ordering',
  users = 'Users & permissions',
}

export const AUTH_REDIRECT_URL = '/login';
export const RedirectResourceUrls = {
  orders: '/orders',
};

export enum Permissions {
  None = 'None',
  RestrictedReadOnInstitution = 'RestrictedReadOnInstitution',
  ReadOnInstitution = 'ReadOnInstitution', // used for general GET request on an institution specific request
  WriteOnInstitution = 'WriteOnInstitution',
  ReadAll = 'ReadAll',
  WriteAll = 'WriteAll',
  SendReport = 'SendReport',
  ResendReport = 'ResendReport',
  AddendReport = 'AddendReport',
  AccessResults = 'AccessResults', // used for report specific GET request on an institution
  CreateOrder = 'trsa:tr:create', // used for creation an order through POST
  OrderKit = 'OrderKit',
}

export enum UserRole {
  InstitutionUser = 'Institution User',
  OrdersUser = 'Orders User',
  ResultsUser = 'Results User',
}

export type Credentials = {
  email?: string;
  password?: string;
};
export type NextRedirectOptions = {
  ctx: GetServerSidePropsContext;
  resourceName: Resources;
  returnToPath?: string;
  to?: string;
};
export type AuthAndAccessRedirect =
  | {
      redirect: {
        destination: string;
        permanent: boolean;
      };
    }
  | string;

export interface UserInstitution {
  roleName: string;
  primary: boolean;
  institution: Institution;
}

export interface AppUser {
  /**
   * braavos property - should be removed after in https://karius.atlassian.net/browse/ENGT-57343
   */
  effectivePermissions?: Array<Permissions>;
  gravatarUrl?: string;

  /**
   * Logical API token properties
   */
  kariusPermissions?: Array<Permissions>;
  pictureUrl?: string;
  institutions?: UserInstitution[];
  orgId?: string;

  role: UserRole;
  name: string;
  email?: string;
  userName?: string;
  notes?: string;
  institution: Institution;
  lastLogin?: Date;
  numberOfLogins?: number;
  createdAt?: Date;
  modifiedAt?: Date;
  href?: string;
  id?: string;
}

export interface SessionUser extends AppUser {
  access_token?: string;
  refresh_token?: string;
  expires_in?: number;
  isRestricted: boolean;
  canGainAccess: boolean;
}

export type AuthToken = {
  token_type: string;
  expires_in: number;
  access_token: string;
};

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginFormProps {
  loading?: boolean;
  onSubmit: (values: LoginCredentials, showLoginError: (message: any) => void) => void;
  onResetPasswordClick: () => void;
  showUnblockSuccessAlert?: boolean;
}

export const LOGIN_ERROR = 'Wrong email or password.';
